var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "typeChat",
      attrs: {
        title: _vm.$gettext("Seleccionar tema: ") + _vm.type.text,
        tabindex: "0",
        url: _vm.url,
      },
      on: {
        click: function ($event) {
          return _vm.toggleChatWindowStatus(_vm.type)
        },
      },
    },
    [_vm._v(" " + _vm._s(_vm.type.text) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }